import type { RouteRecordRaw } from "vue-router"
import { ensureEmbedAuthenticated } from "@/router/guardians"
import { useUserStore } from "@/store/user-store"
import { isEmbeddedContext, sendToParent } from "@common/services/embed-service"

// Import route meta types
import "./types"

const embedRoutes: RouteRecordRaw[] = [
  {
    path: "/embed",
    meta: { embeddable: true },
    component: () => import("@/modules/embed/employee-view/layouts/EmbeddedEmployeeLayout.vue"),
    beforeEnter: async (to, from) => {
      if (!isEmbeddedContext()) return { name: "home" }
      const authResult = await ensureEmbedAuthenticated(to, from, () => {})
      if (authResult !== true) return authResult

      // In embed mode, always reload user data to ensure the store matches
      // the Bearer token identity. Pinia persistence may hold stale data from
      // a previous session on the same origin (e.g. bare hygieia testing).
      const userStore = useUserStore()
      try {
        await userStore.reloadMe()
        await userStore.loadLinkedCompanyMembers()
      } catch (error) {
        console.error("[embed] Failed to populate user store:", error)
        sendToParent("AUTH_ERROR", { code: "USER_LOAD_FAILED", message: "Failed to load user data" })
        return false
      }

      return true
    },
    children: [
      {
        path: "employee-dashboard",
        name: "embed-employee-dashboard",
        component: () => import("@/modules/embed/employee-view/pages/EmbeddedBenefitsPage.vue")
      },
      {
        path: "employee-dashboard/benefits",
        redirect: { name: "embed-employee-dashboard" }
      },
      {
        path: "employee-dashboard/enrollment-complete/schedule-visit",
        name: "embed-enrollment-schedule-visit",
        component: () =>
          import("@/modules/enrollment-new/pages/post-enrollment-flow/EnrollmentFlowScheduleVisitPage.vue"),
        meta: {
          backRoute: "embed-employee-dashboard"
        }
      },
      {
        path: "employee-dashboard/schedule",
        name: "embed-appointment-scheduling",
        component: () => import("@/modules/scheduling/pages/appointment-scheduling/AppointmentSchedulingPage.vue"),
        beforeEnter: (to) => {
          if (!to.query.visitReasonId || typeof to.query.visitReasonId !== "string") {
            return { name: "embed-enrollment-schedule-visit" }
          }
          return true
        },
        meta: {
          backRoute: "embed-enrollment-schedule-visit"
        }
      },
      {
        path: "employee-dashboard/enrollment-complete/download-app",
        name: "embed-enrollment-download-app",
        component: () =>
          import("@/modules/enrollment-new/pages/post-enrollment-flow/EnrollmentFlowDownloadAppPage.vue"),
        meta: {
          backRoute: "embed-employee-dashboard"
        }
      }
    ]
  }
]

export default embedRoutes
